import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type * as API from '@trinity/chat/api/interfaces/projects';
import { useInvalidateProjectTagsQuery } from './useInvalidateTagsQuery';

type MutationParams = API.DeleteProjectTag.Request;

export const useDeleteTagMutation = (projectId: number) => {
  const invalidateTagsQuery = useInvalidateProjectTagsQuery(projectId);

  const apiClient = useChatApiClient();

  return useMutation({
    mutationKey: ['delete:projects/tags'],
    mutationFn: (data: MutationParams) => {
      return apiClient.projects.deleteProjectTag(data);
    },
    onSuccess: (res: API.DeleteProjectTag.Response, params: MutationParams) => {
      invalidateTagsQuery();
    },
  });
};
